import React from 'react';
import { Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-black border-t border-orange-500/30 py-12">
      <div className="container mx-auto px-4">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <img 
            src="https://customer-assets.emergentagent.com/job_9e3d946b-1d38-4e27-976b-5f99d97c59df/artifacts/7kxjrt23_ChatGPT%20Image%20Jan%2014%2C%202026%20at%2009_53_39%20PM.png" 
            alt="Cheer Wave Productions" 
            className="w-40 h-40 object-contain logo-normal"
          />
        </div>

        {/* Divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-orange-500 to-transparent mb-8"></div>

        {/* Social Link - Instagram Only */}
        <div className="flex justify-center mb-8">
          <a
            href="https://www.instagram.com/cheerwaveproductions?igsh=MTNucWs1aWRheTFhZQ%3D%3D&utm_source=qr"
            target="_blank"
            rel="noopener noreferrer"
            className="p-3 bg-gray-800 hover:bg-orange-500 rounded-full transition-all hover:scale-110 hover:shadow-lg hover:shadow-orange-500/50"
          >
            <Instagram className="h-6 w-6 text-white" />
          </a>
        </div>

        {/* Copyright */}
        <p className="text-center text-gray-400 text-sm">
          © {new Date().getFullYear()} Cheer Wave Productions LLC. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;